import instanceQuery from 'graphql/queries/sales/SalesOrderConfigQuery.graphql';
import defaultQuery from 'graphql/queries/sales/SalesOrderConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/SalesOrderConfigMutation.graphql';
import fragment from 'graphql/fragments/sales/SalesOrderConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const SalesOrderConfig = {
  type: 'OrderConfig',
  title: 'Sales Order Configuration',
  formTitle: 'Sales Order Configuration',
  formUrl: '/Sales/OrderConfig',
  instance: instanceQuery,
  workspace: null,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SALES_ORDER_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default SalesOrderConfig;
